import { SVGProps } from 'react';

const Wheat = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M2 22 16 8m0 0h2a4 4 0 0 0 4-4V2h-2a4 4 0 0 0-4 4zM5 19l1.53 1.53a3.5 3.5 0 0 0 4.94 0L13 19l-1.53-1.53a3.5 3.5 0 0 0-4.94 0 3.5 3.5 0 0 0 0-4.94L5 11l-1.53 1.53a3.5 3.5 0 0 0 0 4.94zm1.53-1.53L5 19m4-4 1.53 1.53a3.5 3.5 0 0 0 4.94 0L17 15l-1.53-1.53a3.5 3.5 0 0 0-4.94 0 3.5 3.5 0 0 0 0-4.94L9 7 7.47 8.53a3.5 3.5 0 0 0 0 4.94zm1.53-1.53L9 15m4-4 1.53 1.53a3.5 3.5 0 0 0 4.94 0L21 11l-1.53-1.53a3.5 3.5 0 0 0-4.94 0 3.5 3.5 0 0 0 0-4.94L13 3l-1.53 1.53a3.5 3.5 0 0 0 0 4.94zm1.53-1.53L13 11"
    />
  </svg>
);
export default Wheat;
